var map = {
	"./ar/activity.json": [
		79831,
		[
			9831
		]
	],
	"./ar/auth.json": [
		62688,
		[
			2688
		]
	],
	"./ar/convert.json": [
		19901,
		[
			9901
		]
	],
	"./ar/core.json": [
		68585,
		[
			8585
		]
	],
	"./ar/core_old.json": [
		54867,
		[
			4867
		]
	],
	"./ar/futures.json": [
		2442,
		[
			2442
		]
	],
	"./ar/interest.json": [
		99800,
		[
			9800
		]
	],
	"./ar/kyc.json": [
		53959,
		[
			3959
		]
	],
	"./ar/margin.json": [
		34716,
		[
			4716
		]
	],
	"./ar/order.json": [
		85638,
		[
			5638
		]
	],
	"./ar/send.json": [
		31939,
		[
			4320
		]
	],
	"./ar/stream.json": [
		45598,
		[
			5598
		]
	],
	"./ar/transfer.json": [
		82053,
		[
			2053
		]
	],
	"./ar/translation.json": [
		10521,
		[
			521
		]
	],
	"./ar/translation_old.json": [
		87715,
		[
			7715
		]
	],
	"./ar/user.json": [
		90857,
		[
			857
		]
	],
	"./en/activity.json": [
		81159,
		[
			1159
		]
	],
	"./en/auth.json": [
		72816,
		[
			2816
		]
	],
	"./en/convert.json": [
		85645,
		[
			5645
		]
	],
	"./en/core.json": [
		60121,
		[
			121
		]
	],
	"./en/core_old.json": [
		41155,
		[
			1155
		]
	],
	"./en/futures.json": [
		54778,
		[
			4778
		]
	],
	"./en/interest.json": [
		88488,
		[
			8488
		]
	],
	"./en/kyc.json": [
		9911,
		[
			9911
		]
	],
	"./en/margin.json": [
		49644,
		[
			9644
		]
	],
	"./en/order.json": [
		84566,
		[
			4566
		]
	],
	"./en/send.json": [
		7008,
		[
			7008
		]
	],
	"./en/stream.json": [
		16142,
		[
			6142
		]
	],
	"./en/transfer.json": [
		83477,
		[
			3477
		]
	],
	"./en/translation.json": [
		29737,
		[
			9737
		]
	],
	"./en/translation_old.json": [
		80595,
		[
			595
		]
	],
	"./en/user.json": [
		47705,
		[
			7705
		]
	],
	"./es/activity.json": [
		48450,
		[
			8450
		]
	],
	"./es/auth.json": [
		25053,
		[
			5053
		]
	],
	"./es/convert.json": [
		33774,
		[
			3774
		]
	],
	"./es/core.json": [
		9452,
		[
			9452
		]
	],
	"./es/core_old.json": [
		28710,
		[
			8710
		]
	],
	"./es/futures.json": [
		19973,
		[
			9973
		]
	],
	"./es/interest.json": [
		4829,
		[
			4829
		]
	],
	"./es/kyc.json": [
		18100,
		[
			8100
		]
	],
	"./es/margin.json": [
		6853,
		[
			6853
		]
	],
	"./es/order.json": [
		89429,
		[
			9429
		]
	],
	"./es/send.json": [
		74549,
		[
			4549
		]
	],
	"./es/stream.json": [
		80431,
		[
			431
		]
	],
	"./es/transfer.json": [
		93260,
		[
			879
		]
	],
	"./es/translation.json": [
		51738,
		[
			1738
		]
	],
	"./es/translation_old.json": [
		93964,
		[
			3964
		]
	],
	"./es/user.json": [
		73524,
		[
			3524
		]
	],
	"./fr/activity.json": [
		71082,
		[
			1082
		]
	],
	"./fr/auth.json": [
		81349,
		[
			1349
		]
	],
	"./fr/convert.json": [
		59241,
		[
			1622
		]
	],
	"./fr/core.json": [
		40628,
		[
			628
		]
	],
	"./fr/core_old.json": [
		88606,
		[
			8606
		]
	],
	"./fr/futures.json": [
		49005,
		[
			9005
		]
	],
	"./fr/interest.json": [
		55381,
		[
			5381
		]
	],
	"./fr/kyc.json": [
		22044,
		[
			2044
		]
	],
	"./fr/margin.json": [
		60909,
		[
			909
		]
	],
	"./fr/order.json": [
		23053,
		[
			3053
		]
	],
	"./fr/send.json": [
		84285,
		[
			4285
		]
	],
	"./fr/stream.json": [
		56983,
		[
			6983
		]
	],
	"./fr/transfer.json": [
		91156,
		[
			1156
		]
	],
	"./fr/translation.json": [
		35570,
		[
			5570
		]
	],
	"./fr/translation_old.json": [
		90420,
		[
			420
		]
	],
	"./fr/user.json": [
		84652,
		[
			4652
		]
	],
	"./hi/activity.json": [
		13419,
		[
			3419
		]
	],
	"./hi/auth.json": [
		96236,
		[
			6236
		]
	],
	"./hi/convert.json": [
		20393,
		[
			393
		]
	],
	"./hi/core.json": [
		21,
		[
			21
		]
	],
	"./hi/core_old.json": [
		52316,
		[
			9935
		]
	],
	"./hi/futures.json": [
		66726,
		[
			6726
		]
	],
	"./hi/interest.json": [
		40332,
		[
			332
		]
	],
	"./hi/kyc.json": [
		85083,
		[
			5083
		]
	],
	"./hi/margin.json": [
		51184,
		[
			1184
		]
	],
	"./hi/order.json": [
		87570,
		[
			7570
		]
	],
	"./hi/send.json": [
		62516,
		[
			2516
		]
	],
	"./hi/stream.json": [
		35138,
		[
			5138
		]
	],
	"./hi/transfer.json": [
		3233,
		[
			3233
		]
	],
	"./hi/translation.json": [
		63805,
		[
			3805
		]
	],
	"./hi/translation_old.json": [
		14311,
		[
			4311
		]
	],
	"./hi/user.json": [
		16693,
		[
			6693
		]
	],
	"./ja/activity.json": [
		57021,
		[
			7021
		]
	],
	"./ja/auth.json": [
		14718,
		[
			4718
		]
	],
	"./ja/convert.json": [
		57179,
		[
			7179
		]
	],
	"./ja/core.json": [
		13211,
		[
			3211
		]
	],
	"./ja/core_old.json": [
		69829,
		[
			9829
		]
	],
	"./ja/futures.json": [
		46064,
		[
			6064
		]
	],
	"./ja/interest.json": [
		38290,
		[
			8290
		]
	],
	"./ja/kyc.json": [
		54681,
		[
			4681
		]
	],
	"./ja/margin.json": [
		26366,
		[
			6366
		]
	],
	"./ja/order.json": [
		24588,
		[
			4588
		]
	],
	"./ja/send.json": [
		97086,
		[
			7086
		]
	],
	"./ja/stream.json": [
		80644,
		[
			644
		]
	],
	"./ja/transfer.json": [
		75207,
		[
			5207
		]
	],
	"./ja/translation.json": [
		91303,
		[
			1303
		]
	],
	"./ja/translation_old.json": [
		20177,
		[
			177
		]
	],
	"./ja/user.json": [
		15287,
		[
			5287
		]
	],
	"./ko/activity.json": [
		38920,
		[
			8920
		]
	],
	"./ko/auth.json": [
		75752,
		[
			3371
		]
	],
	"./ko/convert.json": [
		25404,
		[
			5404
		]
	],
	"./ko/core.json": [
		52750,
		[
			2750
		]
	],
	"./ko/core_old.json": [
		1776,
		[
			1776
		]
	],
	"./ko/futures.json": [
		19531,
		[
			9531
		]
	],
	"./ko/interest.json": [
		19175,
		[
			9175
		]
	],
	"./ko/kyc.json": [
		93006,
		[
			3006
		]
	],
	"./ko/margin.json": [
		60095,
		[
			95
		]
	],
	"./ko/order.json": [
		11603,
		[
			1603
		]
	],
	"./ko/send.json": [
		34011,
		[
			4011
		]
	],
	"./ko/stream.json": [
		12645,
		[
			2645
		]
	],
	"./ko/transfer.json": [
		63574,
		[
			3574
		]
	],
	"./ko/translation.json": [
		91064,
		[
			1064
		]
	],
	"./ko/translation_old.json": [
		91234,
		[
			1234
		]
	],
	"./ko/user.json": [
		4490,
		[
			4490
		]
	],
	"./pt/activity.json": [
		27574,
		[
			7574
		]
	],
	"./pt/auth.json": [
		58041,
		[
			8041
		]
	],
	"./pt/convert.json": [
		19434,
		[
			9434
		]
	],
	"./pt/core.json": [
		60776,
		[
			776
		]
	],
	"./pt/core_old.json": [
		65650,
		[
			5650
		]
	],
	"./pt/futures.json": [
		67361,
		[
			7361
		]
	],
	"./pt/interest.json": [
		73857,
		[
			3857
		]
	],
	"./pt/kyc.json": [
		81739,
		[
			4120
		]
	],
	"./pt/margin.json": [
		24393,
		[
			4393
		]
	],
	"./pt/order.json": [
		817,
		[
			817
		]
	],
	"./pt/send.json": [
		68281,
		[
			8281
		]
	],
	"./pt/stream.json": [
		76371,
		[
			6371
		]
	],
	"./pt/transfer.json": [
		89192,
		[
			9192
		]
	],
	"./pt/translation.json": [
		9345,
		[
			1726
		]
	],
	"./pt/translation_old.json": [
		43440,
		[
			3440
		]
	],
	"./pt/user.json": [
		67856,
		[
			7856
		]
	],
	"./ru/activity.json": [
		17993,
		[
			7993
		]
	],
	"./ru/auth.json": [
		34914,
		[
			4914
		]
	],
	"./ru/convert.json": [
		52799,
		[
			2799
		]
	],
	"./ru/core.json": [
		623,
		[
			623
		]
	],
	"./ru/core_old.json": [
		48009,
		[
			8009
		]
	],
	"./ru/futures.json": [
		90148,
		[
			148
		]
	],
	"./ru/interest.json": [
		9054,
		[
			9054
		]
	],
	"./ru/kyc.json": [
		18613,
		[
			8613
		]
	],
	"./ru/margin.json": [
		22458,
		[
			2458
		]
	],
	"./ru/order.json": [
		60112,
		[
			112
		]
	],
	"./ru/send.json": [
		74906,
		[
			4906
		]
	],
	"./ru/stream.json": [
		51792,
		[
			1792
		]
	],
	"./ru/transfer.json": [
		12219,
		[
			2219
		]
	],
	"./ru/translation.json": [
		6483,
		[
			6483
		]
	],
	"./ru/translation_old.json": [
		81421,
		[
			1421
		]
	],
	"./ru/user.json": [
		41355,
		[
			1355
		]
	],
	"./yue/activity.json": [
		67605,
		[
			7605
		]
	],
	"./yue/auth.json": [
		70038,
		[
			38
		]
	],
	"./yue/convert.json": [
		15507,
		[
			5507
		]
	],
	"./yue/core.json": [
		16435,
		[
			6435
		]
	],
	"./yue/core_old.json": [
		73965,
		[
			3965
		]
	],
	"./yue/futures.json": [
		3880,
		[
			3880
		]
	],
	"./yue/interest.json": [
		22426,
		[
			2426
		]
	],
	"./yue/kyc.json": [
		68945,
		[
			8945
		]
	],
	"./yue/margin.json": [
		82390,
		[
			2390
		]
	],
	"./yue/order.json": [
		63508,
		[
			3508
		]
	],
	"./yue/send.json": [
		73238,
		[
			3238
		]
	],
	"./yue/stream.json": [
		43260,
		[
			3260
		]
	],
	"./yue/transfer.json": [
		69983,
		[
			9983
		]
	],
	"./yue/translation.json": [
		14415,
		[
			4415
		]
	],
	"./yue/translation_old.json": [
		17353,
		[
			7353
		]
	],
	"./yue/user.json": [
		73631,
		[
			3631
		]
	],
	"./zh/activity.json": [
		41028,
		[
			1028
		]
	],
	"./zh/auth.json": [
		73231,
		[
			3231
		]
	],
	"./zh/convert.json": [
		21584,
		[
			1584
		]
	],
	"./zh/core.json": [
		55778,
		[
			5778
		]
	],
	"./zh/core_old.json": [
		27972,
		[
			7972
		]
	],
	"./zh/futures.json": [
		40767,
		[
			767
		]
	],
	"./zh/interest.json": [
		19347,
		[
			9347
		]
	],
	"./zh/kyc.json": [
		13754,
		[
			3754
		]
	],
	"./zh/margin.json": [
		91099,
		[
			1099
		]
	],
	"./zh/order.json": [
		19015,
		[
			9015
		]
	],
	"./zh/send.json": [
		66039,
		[
			6039
		]
	],
	"./zh/stream.json": [
		92273,
		[
			2273
		]
	],
	"./zh/transfer.json": [
		99514,
		[
			9514
		]
	],
	"./zh/translation.json": [
		21844,
		[
			1844
		]
	],
	"./zh/translation_old.json": [
		63934,
		[
			3934
		]
	],
	"./zh/user.json": [
		73966,
		[
			3966
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 46088;
module.exports = webpackAsyncContext;